import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "../images/tmplLogo.png";
import Footer from "./footer";
import SecretKeyDecryption from "./secretKeyDecryption";
import { passwordEncrypt } from "./passwordEncryption"; 

function ResetPassword() {
  const { fetchSecretKey } = SecretKeyDecryption();

  const location = useLocation();
  const { username } = location.state || {};
  const navigate = useNavigate();
  const url = "/api/resetPassword";

  const [admindata, setAdata] = useState({
    username: username,
    password: "",
    passwordConfirm: "",
  });

  const [loading, setLoading] = useState(false);

  const rsubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (admindata.password !== admindata.passwordConfirm) {
      toast.error("Passwords do not match");
      setLoading(false);
      return;
    }

    try {
      const decryptedSecretKey = await fetchSecretKey();
      if (!decryptedSecretKey) {
        setLoading(false);
        return;
      }

      const encryptedPassword = await passwordEncrypt(admindata.password, decryptedSecretKey);
      const encryptedConfirmPassword = await passwordEncrypt(admindata.passwordConfirm, decryptedSecretKey);

      const encryptedData = {
        username: admindata.username,
        password: encryptedPassword,
        passwordConfirm: encryptedConfirmPassword,
      };

      const response = await axios.post(url, encryptedData);
      console.log(response.data);
      setLoading(false);
      toast.success("Password reset successfully");
      navigate("/employeesignin");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Password reset failed");
      setLoading(false);
    }
  };

  const handleChange = (event, field) => {
    let actualValue = event.target.value;
    setAdata({ ...admindata, [field]: actualValue });
  };

  return (
    <div className="bg-primary">
      <div id="layoutAuthentication">
        <div id="layoutAuthentication_content">
          <main>
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-6 col-md-8 col-lg-4">
                  <div className="card card-raised shadow-10 mt-5 mt-xl-10 mb-4">
                    <div className="row g-0">
                      <div className="col-lg-12">
                        <div className="card-body p-5">
                          <div className="text-center">
                            <Link to="/">
                              <img className="mb-3" src={logo} alt="logo" style={{ height: "48px" }} />
                            </Link>
                            <h1 className="display-5 mb-2">Reset Password</h1>
                          </div>
                          <form onSubmit={rsubmit}>
                            <div className="form-floating">
                              <input
                                className="form-control"
                                type="email"
                                id="username"
                                value={admindata.username}
                                readOnly
                                required
                              />
                              <label htmlFor="username">Username <span style={{ color: "red" }}>*</span></label>
                            </div>
                            <br />
                            <div className="form-floating">
                              <input
                                className="form-control"
                                type="password"
                                id="password"
                                value={admindata.password}
                                onChange={(e) => handleChange(e, "password")}
                                required
                              />
                              <label htmlFor="password">New Password <span style={{ color: "red" }}>*</span></label>
                            </div>
                            <br />
                            <div className="form-floating">
                              <input
                                className="form-control"
                                type="password"
                                id="passwordConfirm"
                                value={admindata.passwordConfirm}
                                onChange={(e) => handleChange(e, "passwordConfirm")}
                                required
                              />
                              <label htmlFor="passwordConfirm">Confirm Password <span style={{ color: "red" }}>*</span></label>
                            </div>

                            <div className="form-group d-flex align-items-center justify-content-between mt-4 mb-0">
                              <Link className="small fw-500 text-decoration-none" to="/employeesignin">
                                Return to login!
                              </Link>
                              <input
                                type="submit"
                                value="Reset Password"
                                className="btn btn-primary"
                                disabled={loading}
                              />
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    <div className="text-center mb-5">
                      <Link className="small fw-500 text-decoration-none link-white" to="/register">
                        Need an account? Sign up!
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
        <div id="layoutAuthentication_footer">
          <Footer />
        </div>
      </div>
      {loading && <div className="loading"></div>}
    </div>
  );
}

export default ResetPassword;
